export default class RetailerInterector {

  constructor(service) {
    this.service = service
  }

  getData() {
    return this.service.getData();
  }
}
